// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__xf0EZ","cup":"styles_cup__22PrT","list":"styles_list__lVuIb","selection":"styles_selection__mRjZL"};